module.exports = __webpack_public_path__ + "assets/fa829d812fbd1272cfa878bab5468926.png";